__webpack_require__.p = "/home/runner/work/PetSureQuoteTools/PetSureQuoteTools/dist/brands/pinscom/public/";